module.exports = __webpack_public_path__ + "media/bootstrap-icons/text-indent-right-2b53e9a5.svg";